module.exports = __webpack_public_path__ + "img/comunidad.cb2c2ba5.jpg";